// extracted by mini-css-extract-plugin
module.exports = {"Owner":"Comment_Owner__3sgYe","Date":"Comment_Date__10qt0","CommentCol":"Comment_CommentCol__1S_rt"};